import { QueryClient } from "react-query";

export const queryRelatorioData = new QueryClient({
    defaultOptions: {
        queries:{
            staleTime: 60 * 60 * 2 ,
            cacheTime: 60 * 60 * 2
        }
    }
})